module.exports = __webpack_public_path__ + "img/head-left-icon.44623396.png";